import {
  Input,
  Inject,
  OnInit,
  Output,
  OnChanges,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import { PopulateService } from 'services/populate.service';

import countryHtml from './country.html';
import * as $ from 'jquery';



/**
 * CountryForm Input Component
 *
 * Encapsulates behavior and template to select a country
 */
@Component({
  selector: 'gwFormCountry',
  template: countryHtml,
})
export class FormCountryComponent implements OnInit, OnChanges {
  public GW = (<any>window).GW;
  public countries = this.GW.countries;
  public selectedCountry: any;
  public countrySearch: string;

  @Input() label;
  @Input() country;
  @Input() hint: string;
  @Input() disabled: boolean;
  @Output() onChange = new EventEmitter;

  constructor(
    @Inject('$filter') private $filter,
    @Inject('orderByFilter') private orderBy: ng.IFilterOrderBy,
  ) {}

  async ngOnInit() {
    this.label = this.label || 'Country';
    this.initAutocompleteValue(this.country);
  }

  async ngOnChanges(changes) {
    if (changes.country) {
      this.initAutocompleteValue(this.country);
    }
  }

  /**
   * When a md-select-backdrop exist the page can't be scrolled
   * but the default angular scroll blocker is not working
   *
   * @param show
   */
  onShow(show: boolean) {
    $('html, body')
      .css('overflow', show ? 'hidden' : 'auto');
  }

  clearSearchTerm() {
    this.countrySearch = '';
  }

  initAutocompleteValue(iso: string) {
    this.selectedCountry = this.countries.find(country => country.value === iso);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/country/country.component.ts